import { HeadingNode } from '@lexical/rich-text';
import { TableNode, TableCellNode, TableRowNode } from '@lexical/table';
import './nodes/browser/HashPlaceholderNode/HashPlaceholderComponent.mjs';
import './nodes/browser/ImageNode/ImageComponent.mjs';
import './nodes/headless/FallbackNode/code.mjs';
import './nodes/headless/FallbackNode/code-highlight.mjs';
import { TimePresetNode } from './nodes/headless/TimePresetNode/TimePresetNode.mjs';

const HEADLESS_OPT_IN_FEATURE_NODES = {
  Heading: [HeadingNode],
  Table: [TableNode, TableCellNode, TableRowNode],
  TimePreset: [TimePresetNode]
};
const HEADLESS_OPT_IN_FEATURE_BLOCKS = {
  Heading: ["h1", "h2", "h3"],
  Table: ["table"],
  TimePreset: ["time-preset"]
};

export { HEADLESS_OPT_IN_FEATURE_BLOCKS, HEADLESS_OPT_IN_FEATURE_NODES };
//# sourceMappingURL=constant.headless.mjs.map
